/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://fkt433vfj5emzbqs3iatk4zpzi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "yukikenApi",
            "endpoint": "https://wlo8skjwrj.execute-api.ap-northeast-1.amazonaws.com/dev",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:51c0eb05-222f-4899-9165-f7a9887a2513",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_g6Ccgjbah",
    "aws_user_pools_web_client_id": "435qvgjb8j0b3f47o5dojqpkfh",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "yukikena8ea298cb05441f18f5642bcaab6c1f08f1fb-dev",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "predictions": {
        "identify": {
            "identifyLabels": {
                "proxy": false,
                "region": "ap-northeast-1",
                "defaults": {
                    "type": "identifyLabels"
                }
            }
        }
    }
};


export default awsmobile;
